<template>
	<div ref="rootEl" class="a-infoPopup" :class="{ '-alignLeft': align === 'left', '-alignRight': align === 'right' }">
		<button
			type="button"
            class="a-infoPopup__toggle"
			:aria-expanded="isOpen.toString()"
			:aria-controls="contentId"
			:title="label"
			@click="toggle"
		>
			<svg width="2" height="7" viewBox="0 0 2 7" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
				<path d="M0.0759821 7V1.59562C0.213474 1.65352 0.354583 1.69693 0.499311 1.72588C0.644039 1.74759 0.799621 1.75844 0.966058 1.75844C1.27722 1.75844 1.5703 1.70417 1.84528 1.59562V7H0.0759821ZM0 0.651275C0 0.419711 0.0759821 0.253274 0.227946 0.151965C0.387147 0.050655 0.629566 0 0.955204 0C1.28084 0 1.51964 0.050655 1.67161 0.151965C1.83081 0.253274 1.91041 0.419711 1.91041 0.651275C1.91041 1.0927 1.59201 1.31341 0.955204 1.31341C0.318401 1.31341 0 1.0927 0 0.651275Z" fill="#6E6E6E"/>
			</svg>
			<span class="u-visuallyHidden">{{ label }}</span>
		</button>
		<div
			:id="contentId"
			:hidden="!isOpen"
            class="a-infoPopup__content u-shadow u-fs16"
		>
			<slot v-if="$slots.default"></slot>
			<div v-else v-html="content"></div>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

const props = defineProps( {
	label: { type: String, default: 'Meer informatie' },
	content: { type: String, default: '' },
	defaultOpen: { type: Boolean, default: false },
	id: { type: String, default: '' },
	align: { type: String, default: 'center' }, // 'center' | 'left' | 'right'
} );

const isOpen = ref( props.defaultOpen );
const rootEl = ref( null );
const contentId = ref( props.id || `infoPopup-${ Math.random().toString( 36 ).slice( 2 ) }` );

const toggle = () => {
	isOpen.value = ! isOpen.value;
};

const handleDocumentClick = ( event ) => {
	if ( ! isOpen.value ) {
		return;
	}
	const root = rootEl.value;
	if ( root && ! root.contains( event.target ) ) {
		isOpen.value = false;
	}
};

const handleKeydown = ( event ) => {
	if ( ! isOpen.value ) {
		return;
	}
	if ( event.key === 'Escape' ) {
		isOpen.value = false;
	}
};

onMounted( () => {
	document.addEventListener( 'click', handleDocumentClick, { passive: true } );
	document.addEventListener( 'keydown', handleKeydown );
} );

onBeforeUnmount( () => {
	document.removeEventListener( 'click', handleDocumentClick );
	document.removeEventListener( 'keydown', handleKeydown );
} );

</script>